import { useQuery } from "@tanstack/react-query";
import { fetchPublicDashboardInfo } from "../../../services/b2b-reporting-apiServices";
import useObfuscateDashboardId from "./useObfuscateDashboardId";

const useGettingPublicDashboardInfo = (obfuscatedDashboardId) => {
    const { decode } = useObfuscateDashboardId();
    const seed = 18082050;
    const { organizationUUID, dashboardId } = decode(obfuscatedDashboardId, seed) || {};

    const getPublicDashboardInfo = async () => {
        const response = await fetchPublicDashboardInfo(organizationUUID, dashboardId);
        return response;
    }

    const { data: publicDashboardInfo, error, isLoading } = useQuery({
        queryKey: ['fetchPublicDashboardInfo', obfuscatedDashboardId],
        queryFn: getPublicDashboardInfo,
        enabled: !!obfuscatedDashboardId,
        cacheTime: 0, //15 * 60 * 1000,
    });

    return { publicDashboardInfo, error, isLoading };
}

export default useGettingPublicDashboardInfo;